export default "__VITE_ASSET__sYQowHwf__"